import { useState } from 'react'
import { updateUser } from '@/actions/userActions'
import { getCurrentUser } from '@/selectors/user.selectors'
import { useReselector } from '@/utils/sharedHooks'
import { useAppDispatch } from '@/utils/typeHelpers'
import { Button, Dialog, Text } from '@/ui'

export const DisableDialog = () => {
  const dispatch = useAppDispatch()
  const user = useReselector(getCurrentUser)
  const [open, setOpen] = useState(false)

  const disable2FA = async () => {
    if (!user?.id) {
      return
    }

    const result = await updateUser(user.id, {
      twoFactorAuthEnabled: false,
    })(dispatch)
    if (result) {
      setOpen(false)
    }
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <Dialog.Trigger asChild>
        <Button className="w-full md:w-fit" onClick={() => setOpen(true)}>
          Turn Off
        </Button>
      </Dialog.Trigger>

      <Dialog.Content size="sm" onDismiss={() => setOpen(false)}>
        <Dialog.Title>Turn off two-factor authentication?</Dialog.Title>

        <Text>
          You&#39;ll need to reconfigure your two-factor authentication if you
          decide to start using it again.
        </Text>

        <Dialog.Footer>
          <Button variant="secondary" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button onClick={disable2FA}>Turn Off</Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
